export default "__VITE_ASSET__d4d72da7__"